import { render } from "./Address.vue?vue&type=template&id=6f1401f3&ts=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"

import exportComponent from "/home/yudi/khiza/token-vendor/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__